import axios from "axios";

export default axios.create({
  //baseURL: "http://localhost:3000/api/",
  baseURL: "https://backend-257152871489.europe-west1.run.app/api/",
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
  },

  //baseURL:'http://localhost:8080/api/'
});
//https://web.millergroup.it/api/

//
